import { forwardRef } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { useTranslation } from 'react-i18next';
import { useScrollIntoView } from 'hooks/globals/useScrollIntoView';
import { useShallow } from 'zustand/shallow';
import useComAIStore from '../store/comAIStore';
import AIMessage from './AIMessage';
import ErrorMessage from './ErrorMessage';
import UserMessage from './UserMessage';

const RenderMessage = forwardRef<HTMLDivElement, { id: string }>((props, ref) => {
    const { id } = props;
    const message = useComAIStore((state) => state.chat[id]);

    return (
        <div ref={ref}>
            {message.type === 'user' && message.text && <UserMessage id={id} />}
            {message.type === 'ai' && <AIMessage id={id} />}
        </div>
    );
});

export default function Messages() {
    const chatIds = useComAIStore(useShallow((state) => Object.keys(state.chat)));
    const ref = useScrollIntoView({ deps: [chatIds] });

    return chatIds.map((id) => (
        <ErrorBoundary fallback={<ErrorMessage />} key={id}>
            <RenderMessage id={id} ref={ref} />
        </ErrorBoundary>
    ));
}
